import React from "react";
import { Box, Text } from "@chakra-ui/react";

export const OrganizationInfo = ({ organization }) => {
  return (
    <Box
      style={{
        margin: "20px 0",
      }}
    >
      <Text
        style={{
          fontSize: "18px",
          fontWeight: "600",
          fontFamily: '"Open Sans", sans-serif',
          color: "rgb(66, 71, 112)",
        }}
      >
        {organization?.name}
      </Text>
      <Text
        style={{
          fontFamily: '"Open Sans", sans-serif',
          color: "rgb(66, 71, 112)",
        }}
      >{`${organization?.address?.city}, ${organization?.address?.state}`}</Text>
    </Box>
  );
};
